{
  "title": "Warp Sense",
  "source": "Planescape - Adventures in the Multiverse",
  "levelAndSchool": "2nd-Level divination",
  "level": 2,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (a razorvine leaf)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "For the duration, you sense the presence of portals, even inactive ones, within 30 feet of yourself.",
    "If you detect a portal in this way, you can use your action to study it. Make a DC 15 ability check using your spellcasting ability. On a successful check, you learn the destination plane of the portal and what portal key it requires, then the spell ends. On a failed check, you learn nothing and can't study that portal again using this spell until you cast it again.",
    "The spell can penetrate most barriers but is blocked by 1 foot of stone, 1 inch of common metal, a thin sheet of lead, or 3 feet of wood or dirt."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
